import React, { ComponentType, useContext, useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import UserTileContext from '../../../contexts/userTilesContext';
import { IModule, ISelectableTilePreviewProps } from '../../../interfaces/interfaces';
import { getModuleComponents } from '../../../modules';
import Checkbox from '../Checkbox/Checkbox';

function SelectableTilePreview(props: ISelectableTilePreviewProps): JSX.Element {
  const { tile, displayNumber, onChange, className, isDisabled } = props;
  const userTiles = useContext(UserTileContext);
  const modulesWComponents = getModuleComponents(userTiles.modules);
  const { t } = useTranslation();

  const renderItem = (Wrap: ComponentType | keyof JSX.IntrinsicElements) => {
    const cbId = `pcb-${tile.tileRefId}`;
    const moduleName = tile.module;
    const module: IModule = modulesWComponents[moduleName];

    if (!module || !module.previewComponent) {
      return (
        <>
          <span className="debug-info">Modul-Vorschau {moduleName} nicht verfügbar</span>
        </>
      );
    }

    const moduleProps = { ...module.defaultProps, ...tile.props, ...tile.preview };
    moduleProps.className = moduleName;
    moduleProps.badgeText = displayNumber;

    useEffect(()=>{
      if (isDisabled) {
        // init tooltips
        window.setTimeout(() => {
          // eslint-disable-next-line
          // @ts-ignore
          document.dispatchEvent(new CustomEvent('application.reinit', ['tooltip']));
        }, 500);
      }
    }, []);

    const disabledTextDefault = 'Sie können eine neue Kontakt-Kachel über das Drei-Punkte-Menu einer existierenden Kontakt-Kachel erstellen.';
    const disabledText = <Trans i18nKey="cockpit.appstore.contactTileTooltip">{disabledTextDefault}</Trans>

    return (
      <Wrap key={tile.id} className={`program-list-item ${className || ''} ${tile.isSelected ? 'selected' : ''}`}>
        {/* eslint jsx-a11y/label-has-associated-control: ["error", { assert: "either" } ] */}
        <label htmlFor={cbId}>
          <div className="tile-preview-wrap">
            <div className={`tile-preview ${tile.module}`}>
              {/* eslint-disable-next-line react/jsx-props-no-spreading */}
              <module.previewComponent {...moduleProps} tileId={tile.tileRefId} badgeText={displayNumber} />
            </div>
            <Checkbox
              id={cbId}
              checked={tile.isSelected}
              disabled={isDisabled}
              onChange={(state) => {
                if (onChange && !isDisabled) {
                  onChange(tile, state);
                }
              }}
            />
            {isDisabled ? (
              <div className="blocker">
                <a
                  title={t('cockpit.appstore.contactTileTooltip', disabledTextDefault)}
                  data-tooltip="tooltip-contactTile"
                  data-tooltip-ref=".ic-info"
                  data-tooltip-initial-position="lt_tooltipp_position"
                  data-module="tooltip-link"
                  className="tooltip-ref"
                  tabIndex={0}
                  role="button"
                  aria-describedby="tooltip-contactTile"
                >
                  <span className="link__name" />
                  <span className="tooltip__icon-container">
                    <span className="ic-info" aria-hidden="true" />
                  </span>
                </a>

                <div id="tooltip-contactTile" className="u-hidden tooltip" role="tooltip" data-module="tooltip" aria-hidden="false">
                  <span className="tooltip__close js-tooltip-close" tabIndex={0} role="button">
                    <span className="ic-close" aria-hidden="true" />
                  </span>
                  <span className="tooltip-content">{disabledText}</span>
                  <span className="tooltip__arrow" data-popper-arrow />
                </div>
              </div>
            ) : (
              ''
            )}
          </div>
        </label>
        <h5 className="hl-5">{tile.preview?.headline}</h5>
        <p className="tx_1">{tile.preview?.description}</p>
      </Wrap>
    );
  };

  return <>{renderItem('li')}</>;
}
export default SelectableTilePreview;
